import script from "./TabsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabsView.vue?vue&type=script&lang=ts&setup=true"

import "./TabsView.vue?vue&type=style&index=0&id=174f655c&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174f655c"]])

export default __exports__